var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { withoutUndefinedProperties } from "healthex-common/utils";
import { observable } from "mobx";
export class FormModel {
    constructor(initialInput, requiredFields, onInputUpdate) {
        this.errors = {};
        this.formError = undefined;
        this.input = initialInput;
        this.requiredFields = requiredFields;
        this.onInputUpdate = onInputUpdate;
        this.initialInput = JSON.parse(JSON.stringify(initialInput));
    }
    updateInput(update, fireOnInputUpdate = true) {
        var _a;
        this.input = { ...this.input, ...withoutUndefinedProperties(update) };
        if (fireOnInputUpdate)
            (_a = this.onInputUpdate) === null || _a === void 0 ? void 0 : _a.call(this, update);
    }
    clearErrors() {
        this.errors = {};
        this.formError = undefined;
    }
    addError(property, error) {
        this.errors[property] = error;
    }
    clearError(...properties) {
        properties.forEach((property) => delete this.errors[property]);
    }
    addFormError(error) {
        this.formError = error;
    }
    clearFormError() {
        this.formError = undefined;
    }
    errorCount() {
        return Object.keys(this.errors).length + (this.formError ? 1 : 0);
    }
    hasErrors() {
        return this.errorCount() > 0;
    }
    hasError(...properties) {
        return properties.some((property) => this.errors[property]);
    }
    isFormValid() {
        return this.requiredFields.every((field) => Boolean(this.input[field]) && !this.errors[field]) && !this.hasErrors();
    }
    validateField(property, validator, error) {
        if (this.errors[property])
            return;
        if (!validator(this.input[property])) {
            this.addError(property, error);
        }
    }
    reset() {
        this.input = JSON.parse(JSON.stringify(this.initialInput));
    }
}
__decorate([
    observable
], FormModel.prototype, "input", void 0);
__decorate([
    observable
], FormModel.prototype, "errors", void 0);
__decorate([
    observable
], FormModel.prototype, "formError", void 0);
export function downcastFormModel(formModel) {
    return formModel;
}
